
import Vue from 'vue';
import { FormError } from '@/types/global';
import { ValidateRadioGroup } from '@/plugins/validators';
import { getTranslationString } from '~/utility/i18n';

export default Vue.extend({
  props: {
    id: { type: String, required: true },
    label: { type: String, required: true },
    options: { type: Array<any>, required: true, default: () => [] },
    initialErrors: {
      type: Array,
      default: () => [],
    },
    errorMessages: { type: Array, default: () => [] },
  },
  data() {
    return {
      optional: process.env.STORYBOOK_ENABLED ? 'optional' : getTranslationString(this.$globals, 'optional'),
      element: {} as HTMLFormElement,
      errors: [] as Array<string>,
    };
  },
  mounted() {
    if (!process.env.STORYBOOK_ENABLED) {
      this.element = this.$el.querySelector('#' + this.id) as HTMLFormElement;
      this.element = this.$el.querySelector('#' + this.id) as HTMLFormElement;
      window.addEventListener('validateField', (e: Event) => {
        const eventTarget = (e as CustomEvent).detail.element;
        if (eventTarget.closest('.c-radio-group')) {
          this.validate();
        }
      });
      window.addEventListener('validateForm', (e: Event) => {
        this.validate();
      });

      if (!this.isRequired) {
        this.$el.setAttribute('data-valid', 'true');
      }
    }
    // check for storybook initial errors
    if (this.initialErrors.length) {
      this.errors = (this.initialErrors as Array<string>).map(item => item);
    }
  },
  methods: {
    validate() {
      const radios = this.element.querySelectorAll('input[type=radio]') as NodeListOf<HTMLFormElement>;
      const radioArray = Array.from(radios) as Array<HTMLFormElement>;

      this.errors = ValidateRadioGroup(radioArray, this.errorMessages as Array<FormError>);

      if (this.errors.length === 0) {
        this.$el.setAttribute('data-valid', 'true');
      } else {
        this.$el.removeAttribute('data-valid');
      }
    },
  },
  computed: {
    isRequired(): Boolean {
      const messages = this.errorMessages as Array<FormError>;
      const requiredError = messages.filter((error: FormError) => error.type === 'required');
      return requiredError.length !== 0;
    },
  },
});
